import HttpService from '@/api/HttpService';
import {
  DISABLE_SUBMIT_SEARCH,
  ENABLE_SUBMIT_SEARCH,
  SET_NEW_USER_EMAIL,
  SET_SEARCH_STRING,
  SET_CURRENTLY_SEARCHING_BY,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    investor: {},
    disableSubmitSearch: false,
    impactPreferencesUpdated: false,
    userSearched: null,
    newUserEmail: '',
    searchString: '',
    currentlySearchingBy: 'NAME_EMAIL',
  },
  mutations: {
    [ENABLE_SUBMIT_SEARCH](state) {
      state.disableSubmitSearch = false;
    },
    [DISABLE_SUBMIT_SEARCH](state) {
      state.disableSubmitSearch = true;
    },
    [SET_NEW_USER_EMAIL](state, email) {
      state.newUserEmail = email;
    },
    [SET_SEARCH_STRING](state, searchString) {
      state.searchString = searchString;
    },
    [SET_CURRENTLY_SEARCHING_BY](state, searchingBy) {
      state.currentlySearchingBy = searchingBy;
    },
  },
  actions: {
    getInvestors({ commit }, searchKeyword) {
      commit(DISABLE_SUBMIT_SEARCH);
      return HttpService.get(`users?search=${searchKeyword}`)
        .catch(() => {})
        .then((response) => {
          commit(ENABLE_SUBMIT_SEARCH);
          return response;
        });
    },
    storeUserInSessionStorage({ commit }, userId) {
      sessionStorage.setItem('searchedUser', userId);
    },
    resendEmailVerificationEmail({ commit }, email) {
      return HttpService.post('user/resend-verification-email', { email });
    },
    getAnnouncement() {
      return HttpService.getV2('settings/announcement').catch(() => ({}));
    },
    createAnnouncement({ commit }, announcement) {
      return HttpService.postV2('settings/announcement', { ...announcement });
    },
    storeAccountTypeInSessionStorage({ commit }, accountType) {
      sessionStorage.setItem('accountTypeToCreate', accountType);
    },
    updateFinancialAdvisor(
      { commit },
      { userId, provideLogin, payload, enableMfa = false },
    ) {
      return HttpService.putV2(
        `users/${userId}/financial-advisor?provideLogin=${provideLogin}&enableMfa=${enableMfa}`,
        payload,
      )
        .then(response => response)
        .catch((error) => {
          throw error;
        });
    },
    addUserComments(
      { commit },
      { userId, payload },
    ) {
      return HttpService.putV2(`users/${userId}/comments`, payload)
        .then(response => response)
        .catch((error) => {
          throw error;
        });
    },
    mergePartialUser(
      { commit },
      { partialUserId, targetUserId },
    ) {
      return HttpService.postV2('users/merge-partial-user', {
        partialUserId,
        targetUserId,
      })
        .then(response => response)
        .catch((error) => {
          throw error;
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js